import { useEffect, useState } from "react";
import { apiFetchBlob } from "@/lib/api";
import { artworkTemplatesApi } from "@/lib/artwork-templates";

export interface ArtworkThumbnailProps {
  templateId: number;
  bust?: number;
}

// The image endpoint requires a bearer token, which a bare <img src> cannot attach.
// Fetch the bytes via apiFetchBlob, then expose them through a blob: URL for the <img>.
// `bust` lets the caller force a refetch (e.g. right after an upload).
export function ArtworkThumbnail({ templateId, bust }: ArtworkThumbnailProps) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let created: string | null = null;
    setFailed(false);
    setUrl(null);

    apiFetchBlob(artworkTemplatesApi.imageUrl(templateId))
      .then((blob) => {
        if (cancelled) return;
        created = URL.createObjectURL(blob);
        setUrl(created);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (created) URL.revokeObjectURL(created);
    };
  }, [templateId, bust]);

  if (failed) return <p className="text-sm text-muted-foreground">No reference image.</p>;
  if (!url) return <p className="text-sm text-muted-foreground">Loading…</p>;
  return <img src={url} alt="Reference artwork" className="max-h-48 rounded border" />;
}
